import { formatPrice } from '@bwoty-web/price-formatter';

const currencyToMucdDictionary = {
  SEK: 'vs',
  NOK: 'vn',
  DKK: 'sd',
  EUR: 'tf',
};

export function formatPriceCurrency(price, currency) {
  return formatPrice(price, currencyToMucdDictionary[currency]);
}
